import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  Icon,
  Tab,
  Typography,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import { useEffect, useState } from "react";
import MainCard from "components/MainCard";
import { BarChartOutlined } from "@ant-design/icons";
import { AutoCompleteElement } from "components/AutoComplete";
import { useCourseValuesQuery } from "features/course/api/hooks";
import { IDropdownModel } from "common/models/IDropdownModel";
import { useSpecializationValuesQuery } from "features/specialization/api/hooks";
import { useForm } from "react-hook-form";
import { IYearWiseMemberResult } from "features/dashboard/api/types";
import { GetYearWiseMember } from "features/dashboard/api/hooks";
import ProgramWiseCount from "./ProgramWiseCount";
import CourseWiseCount from "./CourseWiseCount";
import SpecializationWiseCount from "./SpecializationWiseCount";
import InstituteWiseCount from "./InstituteWiseCount";
import { useCommunityWiseValuesQuery as useInstituteValues } from "features/institute/api/hooks";
import { GetProgrambyCommunity } from "features/member/api/hooks";
import api from "utils/api";
import { useBatchValuesQuery } from "features/testimonial/api/hooks";
const TabsList = () => {
  const [tabvalue, setTabValue] = useState("1");
  const [loading, setLoading] = useState(false);
  const [exportloading, setExportLoading] = useState(false);

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const [filterModel, setFilterModel] = useState({
    filter: {
      instituteID: null,
      courseID: null,
      specializationID: null,
      programID: null,
      year: null,
    },
  });

  const [data, setData] = useState<IYearWiseMemberResult>();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      instituteID: null,
      courseID: null,
      specializationID: null,
      programID: null,
      year: null,
    },
  });
  const memberQuery = GetYearWiseMember(filterModel);

  const onSubmit = handleSubmit((filter) => {
    setFilterModel({
      filter: {
        instituteID: filter.instituteID ? filter.instituteID : null,
        courseID: filter.courseID ? filter.courseID : null,
        specializationID: filter.specializationID
          ? filter.specializationID
          : null,
        programID: filter.programID ? filter.programID : null,
        year: filter.year ? filter.year : null,
      },
    });
  });
  useEffect(() => {
    setLoading(memberQuery.isFetching);
  }, [memberQuery.isFetching]);

  useEffect(() => {
    if (memberQuery.data?.status === 200) {
      setData(memberQuery?.data?.apiData);
    }
  }, [memberQuery.data]);

  useEffect(() => {
    memberQuery.refetch();
  }, [filterModel]);

  const handleClear = () => {
    setFilterModel((prev) => ({
      ...prev,
      filter: {
        instituteID: null,
        courseID: null,
        specializationID: null,
        programID: null,
        year: null,
      },
    }));
    reset();
  };

  const apiURLProgram = "api/ExcelDownload/ProgramYearWiseCountExports";
  const fileNameProgram = "ProgramYearWiseMemberCount";
  const handleExportProgram = () => {
    setExportLoading(true);
    api.downloadExcel(
      apiURLProgram,
      fileNameProgram,
      filterModel.filter,
      setExportLoading,
    );
  };

  const apiURLCourse = "api/ExcelDownload/CourseYearWiseCountExports";
  const fileNameCourse = "CourseYearWiseMemberCount";
  const handleExportCourse = () => {
    setExportLoading(true);
    api.downloadExcel(
      apiURLCourse,
      fileNameCourse,
      filterModel.filter,
      setExportLoading,
    );
  };

  const apiURLSpecialization =
    "api/ExcelDownload/SpecializationYearWiseCountExports";
  const fileNameSpecialization = "SpecializationYearWiseMemberCount";
  const handleExportSpecialization = () => {
    setExportLoading(true);
    api.downloadExcel(
      apiURLSpecialization,
      fileNameSpecialization,
      filterModel.filter,
      setExportLoading,
    );
  };

  const apiURLInstitute = "api/ExcelDownload/InstituteYearWiseCountExports";
  const fileNameInstitute = "InstituteYearWiseMemberCount";
  const handleExportInstitute = () => {
    setExportLoading(true);
    api.downloadExcel(
      apiURLInstitute,
      fileNameInstitute,
      filterModel.filter,
      setExportLoading,
    );
  };

  //#region Institute
  const instituteQuery = useInstituteValues();
  const [instituteOptions, setInstituteOptions] = useState<IDropdownModel[]>(
    [],
  );
  useEffect(() => {
    setInstituteOptions(instituteQuery?.data?.apiData || []);
  }, [instituteQuery.data?.apiData]);
  //#endregion

  //#region Course
  const courseQuery = useCourseValuesQuery();
  const [courseOptions, setCourseOptions] = useState<IDropdownModel[]>([]);
  useEffect(() => {
    setCourseOptions(courseQuery?.data?.apiData || []);
  }, [courseQuery.data]);
  //#endregion

  //#region Specialization
  const specializationQuery = useSpecializationValuesQuery();
  const [specializationOptions, setSpecializationOptions] = useState<
    IDropdownModel[]
  >([]);
  useEffect(() => {
    setSpecializationOptions(specializationQuery?.data?.apiData || []);
  }, [specializationQuery.data]);

  //#endregion

  //#region Program
  const programQuery = GetProgrambyCommunity();
  const [programOptions, setProgramOptions] = useState<IDropdownModel[]>([]);
  useEffect(() => {
    setProgramOptions(programQuery?.data?.apiData || []);
  }, [programQuery.data?.apiData]);
  //#endregion

  //#region Batch
  const batchQuery = useBatchValuesQuery();
  const [batchOptions, setBatchOptions] = useState<IDropdownModel[]>([]);
  useEffect(() => {
    setBatchOptions(batchQuery?.data?.apiData || []);
  }, [batchQuery.data?.apiData]);
  //#endregion

  useEffect(() => {
    const raw = batchQuery?.data?.apiData || [];
    const formatted = raw.map((item) => ({
      id: item.name,
      name: item.name,
    }));
    setBatchOptions(formatted);
  }, [batchQuery.data?.apiData]);

  // //#region Batch
  // const yearOptions = [];
  // for (let year = 1989; year <= new Date().getFullYear(); year++) {
  //   const nextYear = year + 1;
  //   yearOptions.push({
  //     value: nextYear,
  //     label: `${year}-${nextYear.toString().slice(-2)}`,
  //   });
  // }
  // yearOptions.sort((a, b) => b.value - a.value);
  // //#endregion

  return (
    <>
      <MainCard sx={{ my: 1 }}>
        <Typography variant="h3">
          <Icon sx={{ marginRight: "5px" }}>
            <BarChartOutlined />
          </Icon>
          Year Wise Members Statistics
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={onSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6} lg={4}>
              <FormControl fullWidth>
                <AutoCompleteElement
                  options={instituteOptions}
                  control={control}
                  name="instituteID"
                  label="Institute / School"
                  placeholder="Select Institute / School"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} md={6} lg={4}>
              <FormControl fullWidth>
                <AutoCompleteElement
                  options={courseOptions}
                  control={control}
                  name="courseID"
                  label="Course"
                  placeholder="Select Course"
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} md={6} lg={4}>
              <FormControl fullWidth>
                <AutoCompleteElement
                  options={specializationOptions}
                  control={control}
                  name="specializationID"
                  label="Specialization"
                  placeholder="Select Specialization"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} md={6} lg={4}>
              <FormControl fullWidth>
                <AutoCompleteElement
                  options={programOptions}
                  control={control}
                  name="programID"
                  label="Program"
                  placeholder="Select Program"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} md={6} lg={4}>
              <FormControl fullWidth>
                {/* <SelectField
                  control={control}
                  placeholder="Select Passout Batch/Year"
                  label="Passout Batch/Year"
                  name="year"
                  options={yearOptions}
                /> */}
                <AutoCompleteElement
                  options={batchOptions}
                  control={control}
                  name="year"
                  label="Passout Batch/Year"
                  placeholder="Select Passout Batch/Year"
                />
              </FormControl>
            </Grid>
            <Grid
              item
              display={"flex"}
              alignItems={"center"}
              xs={6}
              md={4}
              lg={3}
            >
              <Button type="submit" variant="contained">
                Show
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                sx={{ ml: 1 }}
                onClick={handleClear}
              >
                Clear
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Divider sx={{ py: 1 }} />
        <Box sx={{ width: "100%", typography: "body1", marginTop: "20px" }}>
          {memberQuery.isFetching ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="200px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <TabContext value={tabvalue}>
              <Box>
                <TabList
                  onChange={handleChange}
                  aria-label="Dashboard statistics api"
                  sx={{ marginBlock: "0em", color: "#fafafa" }}
                >
                  <Tab
                    sx={{
                      backgroundColor: "#fafafa",
                      marginInline: "4px",
                    }}
                    label="Program Wise Statistics"
                    value="1"
                  />
                  <Tab
                    sx={{
                      backgroundColor: "#fafafa",
                      marginInline: "4px",
                    }}
                    label="Course Wise Statistics"
                    value="2"
                  />
                  <Tab
                    sx={{
                      backgroundColor: "#fafafa",
                      marginInline: "4px",
                    }}
                    label="Specialization Wise Statistics"
                    value="3"
                  />
                  <Tab
                    sx={{
                      backgroundColor: "#fafafa",
                      marginInline: "4px",
                    }}
                    label="Institute Wise Statistics"
                    value="4"
                  />
                </TabList>
              </Box>
              <TabPanel
                value="1"
                sx={{ paddingInline: "0px", marginTop: "-5px" }}
              >
                <ProgramWiseCount
                  data={data?.programAndYearWiseMember}
                  exportProgram={handleExportProgram}
                  loading={exportloading}
                />
              </TabPanel>
              <TabPanel
                value="2"
                sx={{ paddingInline: "0px", marginTop: "-5px" }}
              >
                <CourseWiseCount
                  data={data?.courseAndYearWiseMember}
                  exportCourse={handleExportCourse}
                  loading={exportloading}
                />
              </TabPanel>
              <TabPanel
                value="3"
                sx={{ paddingInline: "0px", marginTop: "-5px" }}
              >
                <SpecializationWiseCount
                  data={data?.specializationAndYearWiseMember}
                  exportSpecialization={handleExportSpecialization}
                  loading={exportloading}
                />
              </TabPanel>
              <TabPanel
                value="4"
                sx={{ paddingInline: "0px", marginTop: "-5px" }}
              >
                <InstituteWiseCount
                  data={data?.instituteAndYearWiseMember}
                  exportInstitute={handleExportInstitute}
                  loading={exportloading}
                />
              </TabPanel>
            </TabContext>
          )}
        </Box>
      </MainCard>
    </>
  );
};
export default TabsList;
